import { Currency, CurrencyState } from 'types/subscription'

import { currencySymbolsMap } from './currencySymbolsMap'

// Ported from qr-api's src/modules/utils/get-currency-symbol.ts — static-map
// lookup first, falling back to Intl only for currencies not in the map.
// No locale param: qr-api's version doesn't use one either (the fallback
// path hardcodes 'en-US').
export const getCurrencySymbol = (currency: string): string => {
	const code = currency.toUpperCase()

	if (!Object.prototype.hasOwnProperty.call(currencySymbolsMap, code)) {
		return (0)
			.toLocaleString('en-US', {
				style: 'currency',
				currency,
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
			})
			.replace(/\d/g, '')
			.trim()
	}

	return currencySymbolsMap[code] ?? code
}

export const isExactPrice = (currency: string): boolean =>
	['JPY', 'CLP', 'KRW', 'VND'].includes(currency)

export const DEFAULT_CURRENCY: Currency = {
	isDefault: true,
	symbol: '$',
	code: 'USD',
}

export const DEFAULT_CURRENCY_STATE: CurrencyState = {
	currency: DEFAULT_CURRENCY,
	loaded: false,
	currencyList: [],
}
